module.exports = __webpack_public_path__ + "static/media/bt_top_locomo_over.ab126e86.png";